import { ReactNode } from "react";
import loadingGif from "../../assets/loading.gif";
import FakeLink from "../FakeLink/FakeLink";
import styles from "./LoadingScreen.module.scss";

export default function LoadingScreen({
  title,
  children,
}: {
  title?: string;
  children?: ReactNode;
}) {
  return (
    <div className={styles.loading}>
      <img
        src={loadingGif}
        width="300"
        height="180"
        alt="Loading...."
      />
      {title && <div className={styles.title}>{title}</div>}
      {children && <div>{children}</div>}
      <FakeLink
        onClick={() => window.location.reload()}
        className={styles.button}
      >
        Refresh
      </FakeLink>
    </div>
  );
}
